import { useEffect, useState } from 'react';

export const useStoreAddress = ({ setValue, responseZipCode, dataRowEdit, watch }) => {
  const [state, setState] = useState(dataRowEdit?.state || '');
  const [municipality, setMunicipality] = useState(dataRowEdit?.municipality || '');
  const [neighborhood, setNeighborhood] = useState(dataRowEdit?.neighborhood || '');

  const postalCodeValue = watch('postalCode');
  const isPostalCodeValid = /^[0-9]{5}$/.test(postalCodeValue || '');

  useEffect(() => {
    if (responseZipCode) {
      if (responseZipCode.state) {
        setState(responseZipCode.state);
        setValue('state', responseZipCode.state);
      }
      if (responseZipCode.municipality) {
        setMunicipality(responseZipCode.municipality);
        setValue('municipality', responseZipCode.municipality);
      }
    }
  }, [responseZipCode, setValue]);

  const handleStateChangeAndClear = (event) => {
    handleStateChange(event);
    setValue('municipality', '');
    setValue('neighborhood', '');
    setMunicipality('');
    setNeighborhood('');
  };

  const handleStateChange = (event) => {
    const value = event.target.value;
    setState(value);
    setValue('state', value);
  };

  const handleMunicipalityChange = (event) => {
    const value = event.target.value;
    setMunicipality(value);
    setValue('municipality', value);
  };

  const handleNeighborhoodChange = (event) => {
    const value = event.target.value;
    setNeighborhood(value);
    setValue('neighborhood', value);
  };

  return {
    state,
    municipality,
    neighborhood,
    handleStateChange,
    handleMunicipalityChange,
    handleNeighborhoodChange,
    setMunicipality,
    setNeighborhood,
    setState,
    handleStateChangeAndClear,
    isPostalCodeValid,
    postalCodeValue,
  };
};
